<button
	*ngIf="mockMode && isDev"
	class="flex items-center z-[1337] fixed bottom-l left-8xl bg-interaction-grey-link hover:bg-interaction-grey-hover transition-all hover:scale-110 drop-shadow-md rounded-full p-xs"
	(click)="openMockValuesPopup()"
>
	<vis-ods-icon-component
		name="userManagement"
		class="flex items-center w-m h-m"
	></vis-ods-icon-component>
</button>
